import React from 'react';
import '../eyeTest.css';
import { useStaticQuery, graphql } from 'gatsby';
import { useRecoilState } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import { eyeTestState } from '../../../../utils/recoil/eyeTest';
import { Image } from '../../../UI/Media';
import { withLocale } from '../../../../utils/hocs';
import { formatContentfulComponentProps } from '../../../../utils/globals';
import { Button } from '../../../UI/Elements';

export const EyeTestStart = withLocale(({ locale, scrollUp, startStep }) => {
  const { eyeTestLookImage, label, online, print } =
    formatContentfulComponentProps(startStep);
  const [eyeTest, setEyeTest] = useRecoilState(eyeTestState);

  // Get all PDF files
  const { allFile } = useStaticQuery(
    graphql`
      query {
        allFile(
          filter: {
            name: {
              in: [
                "eye-test-ca"
                "eye-test-de"
                "eye-test-es"
                "eye-test-eu"
                "eye-test-fr"
                "eye-test-gb"
                "eye-test-it"
                "eye-test-nl"
                "eye-test-pt"
                "eye-test-us"
              ]
            }
          }
        ) {
          nodes {
            publicURL
            absolutePath
            name
          }
        }
      }
    `
  );

  const handleStart = () => {
    setEyeTest({
      ...eyeTest,
      isInit: false,
    });
    scrollUp();
  };

  const returnLocalEyeTestPdfHref = () => {
    const localisedPdf = allFile.nodes.filter((pdf) =>
      pdf.name.includes(locale[0].split('-')[1])
    );
    return localisedPdf[0] ? localisedPdf[0].publicURL : '';
  };

  return (
    <div className='w-full eye-test-container flex flex-col lg:flex-row'>
      <div className='block lg:absolute lg:right-0 w-full h-full pb-10 lg:pb-0 lg:w-1/2'>
        <Image
          width='100%'
          height='100%'
          description={eyeTestLookImage.title}
          media={{ file: { url: eyeTestLookImage.media.file.url } }}
          objectFit='cover'
        />
      </div>
      <div className='w-full flex flex-col justify-center items-start lg:pr-10 lg:w-1/2'>
        <div className='w-full flex flex-col items-start'>
          <div className='pt-5 pb-7 lg:pt-0'>
            <Label
              weight='bold'
              size='4xl'
              text={formatContentfulComponentProps(online).label?.text}
            />
          </div>
          <Label
            size='lg'
            text={formatContentfulComponentProps(online).subLabel.text}
          />
          <div className='pt-10'>
            <Button
              type='contained'
              color={{ classname: 'reading' }}
              onClick={handleStart}
              label={{
                text: formatContentfulComponentProps(online).button.label?.text,
              }}
            />
          </div>
        </div>
        <div className='w-full flex justify-center py-10'>
          <span className='font-gilmer font-bold line-through-word'>
            {`   ${label?.text}   `}
          </span>
        </div>
        <div className='flex flex-col items-start'>
          <div className='pb-7'>
            <Label
              weight='bold'
              size='4xl'
              text={formatContentfulComponentProps(print).label?.text}
            />
          </div>
          <Label
            size='lg'
            text={formatContentfulComponentProps(print).subLabel.text}
          />
          <div className='pt-10 pb-5 w-full lg:pb-0'>
            <a
              href={returnLocalEyeTestPdfHref()}
              target='_blank'
              rel='noreferrer'
              style={{ textDecoration: 'none' }}>
              <Button
                type='outlined'
                label={{
                  text: formatContentfulComponentProps(print).button.label
                    ?.text,
                }}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
});
